import React from 'react';
import './Download.scss';
import AppleImage from '../../assets/AppleImage.png';
import PlayStoreImage from '../../assets/PlayStoreImage.png';

export default function Download() {
  return (
    <section className='download-container'>
      <h2>Download MyPDF Today!</h2>
      <p>From Edits to Exports — Handle PDFs with Ease.</p>
      
      <section className='store-container'>
        <div className='apple-store-container'>
          <div className='apple-image-container'>
            <img src={AppleImage} alt="apple store" />
          </div>
          <div className='store-detailsContainer'>
            <p>Download on</p>
            <h2>Apple store</h2>
          </div>
        </div>

        <div className='google-playStore-container'>
          <div className='playstore-image-container'>
            <img src={PlayStoreImage} alt="playstore" />
          </div>
          <div className='store-detailsContainer'>
            <p>Get it on</p>
            <h2>Playstore</h2>
          </div>
        </div>
      </section>
    </section>
  )
}
